import z from 'zod/v3';

export const EventSchema = z.object({
  category: z.string(),
  description: z.string().optional(),
  end: z.string(),
  location: z.string().optional(),
  start: z.string(),
  summary: z.string(),
  url: z.string().url().optional(),
});

export type Event = z.infer<typeof EventSchema>;
